import * as R from 'ramda'
import { DEFAULT_ERROR } from '@/constants/messages'

/**
 * This function can be used to pick error message from Error object thrown by axios
 *
 * If it is not able to find error in response.data.message, it should return DEFAULT_ERROR
 */
export default R.compose(
  R.defaultTo(DEFAULT_ERROR),
  R.path(['response', 'data', 'message'])
)
